







































































import { Component, Prop, Vue } from "vue-property-decorator";
import { BerkasRm } from "@/services/BerkasRmService";

@Component
export default class BerkasTable extends Vue {
  @Prop({ default: () => [] }) items!: BerkasRm[];
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: "Belum ada berkas." }) emptyText!: string;
  @Prop({ default: false }) readOnly!: boolean;
  @Prop({ default: false }) showRegister!: boolean;

  headers = [
    { text: "Jenis", value: "jenis_berkas_label", width: 150 },
    { text: "Nama File", value: "nama_file" },
    { text: "Ukuran", value: "file_size", width: 100 },
    { text: "Keterangan", value: "keterangan" },
    { text: "Upload oleh", value: "uploader_name", width: 160 },
    { text: "Tanggal", value: "created_at", width: 160 },
    { text: "Aksi", value: "actions", sortable: false, width: 140 }
  ];

  get visibleHeaders() {
    if (!this.showRegister) return this.headers;
    const rest = this.headers.slice(1);
    return [
      this.headers[0],
      { text: "Kunjungan", value: "register_id", width: 120 },
      ...rest
    ];
  }

  iconFor(mime: string): string {
    if (!mime) return "mdi-file-outline";
    if (mime === "application/pdf") return "mdi-file-pdf-box";
    if (mime.startsWith("image/")) return "mdi-file-image";
    return "mdi-file-outline";
  }

  humanSize(bytes: number): string {
    if (!bytes) return "-";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
  }

  formatDateTime(iso: string): string {
    if (!iso) return "-";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    const pad = (n: number) => n.toString().padStart(2, "0");
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(
      d.getHours()
    )}:${pad(d.getMinutes())}`;
  }
}
